var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssuers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4078 6.07H0.0078125V3.34L13.2078 0L26.4178 3.34L26.4078 6.07Z",
    fill: "#3E83F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0199986 26.4197H26.41L26.43 23.7197H0L0.0199986 26.4197Z",
    fill: "#3E83F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0634 21.1098H22.9334V9.57984H25.0634L25.0534 6.83984H1.53344V9.56984L3.19344 9.57984V21.0998L1.52344 21.1098V22.9398H25.0534V21.1098H25.0634ZM5.93344 21.1098V9.56984H8.81344V21.0898L5.93344 21.1098ZM11.7034 21.1098V9.56984H14.5834V21.0898L11.7034 21.1098ZM17.3134 21.1098V9.56984H20.1934V21.0898L17.3134 21.1098Z",
    fill: "#3E83F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuers);
export default __webpack_public_path__ + "static/media/issuers.62c0d17ee4280719270ee5b953f11eb7.svg";
export { ForwardRef as ReactComponent };